// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"843":"bb7e947d6f96b380","2888":"0c074488dca611fd"}[chunkId] + ".css";
};